export default __webpack_public_path__ + "7db567630d1bcf62bf516445f93da4fb.png";